/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isObject, isString } from 'lodash';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

const __vue_script__ = {
    name: 'AppContainerPicker',

    components: { BaseSelect },

    extends: BaseControl,

    props: {
        value: {
            type: [String, Object],
            default: null
        },

        openDirection: {
            type: String,
            default: null
        },

        org: {
            type: String,
            default: undefined
        },

        onlyNonUniqueEmailApps: {
            type: Boolean,
            default: false
        },

        emitObject: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            apps: [],
            canEdit: true,
            loading: true,
            ready: false,
            setValueAfterReady: false,
            problem: null,
            userIsAdminOrSupport: this.$services.user.matchesRoles(
                { globalRole: 'superadmin' },
                { globalRole: 'spotme_support' }
            ),
            uninitialized: true
        };
    },

    computed: {
        innerValue: {
            /** @returns {string|object} */
            get() {
                if (isObject(this.value)) {
                    return this.value;
                }
                return this.apps.find(app => app.fp_ext_id === this.value) || {};
            },

            /** @param {object|null} value */
            set(value) {
                if (this.uninitialized) {
                    this.uninitialized = false;
                    return;
                }

                if (this.emitObject) {
                    this.$emit('input', value);
                } else {
                    this.$emit('input', value ? value.fp_ext_id : undefined);
                }
            }
        }
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                if (this.ready) {
                    this.setValue();
                } else {
                    this.setValueAfterReady = true;
                }
            }
        },

        ready(value) {
            if (value && this.setValueAfterReady) {
                this.setValue();
            }
        },

        async org() {
            await this.loadApps();
        }
    },

    async created() {
        await this.loadApps();
    },

    methods: {
        /**
         * Loads the list of apps.
         */
        async loadApps() {
            try {
                this.loading = true;
                let apps = await this.$services.branding.getAllBrandings();

                if (this.org) {
                    apps = apps.filter(
                        app => app.fp_ext_id === this.$const.APP_BRANDING_EVENTSPACE.fp_ext_id
                        || (app.fp_owner || this.$const.SPOTME_ORG_ID) === this.org
                    );
                }

                if (this.onlyNonUniqueEmailApps) {
                    apps = apps.filter(app => app.allow_non_unique_email || app.fp_ext_id === this.innerValue);
                }

                for (const app of apps) {
                    app.label = `${app.springboard_name} (${app.fp_ext_id})`;
                }

                this.apps = apps;
                this.$emit('loaded', this.apps);
            } catch (error) {
                console.error('[AppContainerPicker] Error loading apps', error);
            } finally {
                this.loading = false;
                this.ready = true;
            }
        },

        setValue() {
            if (!isString(this.value)) {
                this.uninitialized = false;
                return;
            }

            let app = this.apps.find(app => app.fp_ext_id === (this.value.fp_ext_id || this.value));

            if (!app) {
                // user do not know the current app because he's coming from an org he has no access to
                // he should not be able to change it, so we clear the list of available apps to be used to prevent that.
                console.warn('[AppContainerPicker] Cannot find the branding app, so change of app disabled');
                const fakeApp = { fp_ext_id: this.value, label: this.value, _id: this.value };
                app = fakeApp;
                this.apps.push(fakeApp);
                this.canEdit = this.userIsAdminOrSupport;
                this.problem = this.$t('general_settings.messages.app_not_found');
            }

            this.innerValue = app;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"in-page medium form-group",attrs:{"status":_vm.loading}},[_c('base-select',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.apps.length),expression:"apps.length"}],ref:"container_app",staticClass:"app-container-picker",attrs:{"allow-empty":false,"open-direction":_vm.openDirection,"options":_vm.apps,"disabled":_vm.disabled || !_vm.canEdit,"track-by":"_id","warning":_vm.problem},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'base-select',_vm.$props,false))],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AppContainerPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__